import type { InventoryVehicle } from '@carvana/merch-contracts';
import { useContext } from 'react';
import FavoritesContext from '~/context/home/FavoritesContext';
import RecentVehiclesContext from '~/context/home/RecentVehiclesContext';
import SuggestedForYouContext from '~/context/home/SuggestedForYouContext';

export enum VDPLinkTitles {
  Favorite = 'Favorites',
  Recent = 'Recently viewed',
  Suggested = 'Suggested vehicles',
  None = ''
}

type HookReturnType = {
  header: VDPLinkTitles;
  showLink?: boolean;
  showLoading: boolean;
  vehicles: InventoryVehicle[];
};

export default function useGetVDPLinksToShow(): HookReturnType {
  const {
    favoriteVehiclesFromSearch: {
      data: favoriteVehicles,
      isLoaded: isFavoritesLoaded
    }
  } = useContext(FavoritesContext);
  const {
    recentVehiclesFromSearch: { data: recentVehicles, isLoaded: isRecentLoaded }
  } = useContext(RecentVehiclesContext);
  const {
    suggestedVehicles: { data: suggestedVehicles, isLoaded: isSuggestedLoaded }
  } = useContext(SuggestedForYouContext);

  const isAllLoaded = isFavoritesLoaded && isRecentLoaded && isSuggestedLoaded;

  const hasFavorites = favoriteVehicles.length > 0;
  const hasRecentVehicles = recentVehicles.length > 0;
  const hasSuggestedVehicles = suggestedVehicles.length > 0;

  if (!isAllLoaded) {
    return { header: VDPLinkTitles.None, vehicles: [], showLoading: true };
  }

  if (hasFavorites) {
    return {
      header: VDPLinkTitles.Favorite,
      showLink: favoriteVehicles.length > 3,
      showLoading: false,
      vehicles: favoriteVehicles.slice(0, 3)
    };
  }

  if (hasRecentVehicles) {
    return {
      header: VDPLinkTitles.Recent,
      showLoading: false,
      vehicles: recentVehicles.slice(0, 3)
    };
  }

  if (!hasRecentVehicles && hasSuggestedVehicles) {
    return {
      header: VDPLinkTitles.Suggested,
      showLoading: false,
      vehicles: suggestedVehicles.slice(0, 3)
    };
  }

  return { header: VDPLinkTitles.None, showLoading: true, vehicles: [] };
}
